import React, { useState,useEffect,useCallback ,useMemo,useLayoutEffect,useRef } from 'react';
import Button from '@mui/material/Button';
import ModalAllder from 'components/layout/ModalAllder';

import ModalSelectMultipleProduct from './../modals/ModalSelectMultipleProduct';
import ModalLoadDocument from './../modals/ModalLoadDocument';
import ModalSelectDocument from './../modals/ModalSelectDocument';
import ModalColumnDisplay from './ModalColumnDisplay';
import ModalProductHistory  from './../modals/ModalProductHistory';
import ModalSort from './../modals/ModalSort';

import ProductRow from './ProductRow';
import Form from 'react-bootstrap/Form';
import { NumericFormat } from 'react-number-format';

import ColumnResizer from "react-table-column-resizer";
import {
    DndContext, 
    closestCenter,
    KeyboardSensor,
    useSensor,
    useSensors,
    DragOverlay,
    MouseSensor,
    TouchSensor,
  } from '@dnd-kit/core';
  import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
  import {
    arrayMove,
    SortableContext,
    verticalListSortingStrategy,
    useSortable
  } from '@dnd-kit/sortable';
  import {CSS} from '@dnd-kit/utilities';



import { nanoid } from '@reduxjs/toolkit';



export default function InfomationProduct({values,setFieldValue,productRow,setProductRow,addProductRow,formdisabled,memberId,businessSlug}){

    const [modal, setModal] = useState({
        open:false,
        x:0,
        y:0,
        width:1400,
        height:650,
        pin:false,
        mode:'normal',
        modalname:"pr-product-select"
    });


    const [modalSort, setModalSort] = useState({
        open:false,
        x:0,
        y:0,
        width:530,
        height:450,
        pin:false,
        mode:'normal',
        modalname:"pr-product-sort"
    });

    const [modalDisplayColumn, setModalDisplayColumn] = useState({
        open:false,
        x:0,
        y:0,
        width:530,
        height:670,
        pin:false,
        mode:'normal',
        modalname:"pr-product-display"
    });

    const [modalLoadDocument, setModalLoadDocument] = useState({
        open:false,
        x:0,
        y:0,
        width:1230,
        height:670,
        pin:false,
        mode:'normal',
        modalname:"pr-load-document"
    });

    const [modalSelectDocument, setModalSelectDocument] = useState({
        open:false,
        x:0,
        y:0,
        width:1400,
        height:700,
        pin:false,
        mode:'normal',
        modalname:"pr-select-document"
    });

    const [modalProductHistory, setModalProductHistory] = useState({
        open:false,
        x:0,
        y:0,
        width:1400,
        height:700,
        pin:false,
        mode:'normal',
        modalname:"pr-select-document"
    });



    

    const [columdisplay, setColumDisplay] = useState({
        vat: true,
        remark: true,
    });

    useEffect(() => {
        const idisplay = localStorage.getItem('columdisplay');
        if (idisplay) {
            const parsed = JSON.parse(idisplay);
            // merge กับ default เพื่อป้องกัน key หาย
            setColumDisplay((prev) => ({ ...prev, ...parsed }));
        }
    }, []);


    const [columnsort, setColumnsort] = useState({
        columnsort:['','',''],
        type:"select"
    });

    const [rowCount, setRowCount] = useState(0);


    const checkLength = productRow.filter(
        (row) => row.is_checked === true 
    );



    const [documentName, setDocumentName] = useState('pr');


    const items = useMemo(() => productRow?.map(({ rowID }) => rowID), [productRow]);

    const sensors = useSensors(
        useSensor(MouseSensor, {}),
        useSensor(TouchSensor, {}),
        useSensor(KeyboardSensor, {})
    );

    const [customSort, setCustomSort] = useState(false);
    const [isSavingSort, setIsSavingSort] = useState(false);
    const [activeId, setActiveId] = useState();

    // ดึงค่าสำหรับ sort ตาม field type
    const getSortValue = (row, field) => {
        switch (field) {
            case 'documentDate':
                return row.documentDate ? new Date(row.documentDate).getTime() : 0;
            case 'quantity':
                return Number(row.quantity) || 0;
            case 'taxable_amount':
                return Number(row.taxable_amount) || 0;
            case 'vat':
                return Number(row.vat) || 0;
            case 'total_amount':
                return Number(row.total_amount) || 0;
            default:
                return row[field];
        }
    };

    // เรียงแถวที่มีข้อมูล แล้ว concat แถวว่างไว้ท้าย (ตาม pattern ต้นแบบ)
    const sortProductRows = useCallback((sortConfig) => {
        const activeSorts = sortConfig.sort.filter((s) => s.field !== 0);
        if (activeSorts.length === 0) return;

        const numericFields = ['quantity', 'taxable_amount', 'vat', 'total_amount', 'documentDate'];

        setProductRow((prevRows) => {
            const rowsWithData = prevRows.filter(
                (r) => r.price_per_unit !== '' && r.price_per_unit != null
            );
            const emptyRows = prevRows.filter(
                (r) => r.price_per_unit === '' || r.price_per_unit == null
            );

            rowsWithData.sort((a, b) => {
                for (const sortRule of activeSorts) {
                    const { field, direction = 'asc' } = sortRule;
                    let aValue = getSortValue(a, field);
                    let bValue = getSortValue(b, field);

                    if (!numericFields.includes(field)) {
                        aValue = String(aValue ?? '').toLowerCase();
                        bValue = String(bValue ?? '').toLowerCase();
                    }

                    let comparison = 0;
                    if (aValue < bValue) comparison = -1;
                    else if (aValue > bValue) comparison = 1;

                    if (direction === 'desc') comparison = -comparison;
                    if (comparison !== 0) return comparison;
                }
                return 0;
            });

            return [...rowsWithData, ...emptyRows];
        });
    }, [setProductRow]);

    // บันทึกการจัดเรียงด้วยตนเอง (อัปเดต sort_order + ออกจาก customSort mode)
    const handleSaveSortOrder = async () => {
        try {
            setIsSavingSort(true);
            setProductRow((prevRows) =>
                prevRows.map((item, index) => ({ ...item, sort_order: index + 1 }))
            );
            setCustomSort(false);
        } catch (error) {
            console.error('Error saving sort order:', error);
        } finally {
            setIsSavingSort(false);
        }
    };

    function handleDragStart(event) {
        setActiveId(event.active.id);
        const {active, over} = event;
    }

    function handleDragEnd(event) {
        const {active, over} = event;

        if (active.id !== over.id) {
            setProductRow((productRow) => {
            const oldIndex = items.indexOf(active.id);
            const newIndex = items.indexOf(over.id);
            
            return arrayMove(productRow, oldIndex, newIndex); });
        }
        setActiveId(null);
    }

    function handleDragCancel() {
        setActiveId(null);
    }

    const selectedRow = useMemo(() => {
        if (!activeId) {
          return null;
        }
        const row = productRow.filter((prev) => prev.rowID == activeId  );
        return row;
    }, [activeId ]);

    // array-driven column definitions (reference pattern: filter(Boolean) + map)
    const tableColumns = useMemo(() => [
        { key: 'documentNumber', label: 'เลขที่เอกสาร',  minWidth: 200 },
        { key: 'documentDate',   label: 'วันที่เอกสาร',   minWidth: 200 },
        { key: 'quantity',       label: 'จำนวนรายการ',    minWidth: 100 },
        { key: 'taxable_amount', label: 'มูลค่าก่อนภาษี', minWidth: 100 },
        columdisplay.vat    && { key: 'vat',    label: 'มูลค่าภาษี', minWidth: 100 },
        { key: 'total_amount',   label: 'มูลค่าสุทธิ',    minWidth: 110 },
        columdisplay.remark && { key: 'remark', label: 'หมายเหตุ',   minWidth: 140 },
        { key: 'action',         label: 'จัดการ',          minWidth: 120 },
    ].filter(Boolean), [columdisplay.vat, columdisplay.remark]);

    return (
        <>

            {
                checkLength.length > 0 ? (
                <div className='mb-3'>
        

                    <button type='button' className='btn btn-st-x1 me-2'
                    onClick={() => {
                        const checkLenght = productRow.filter(item => item.is_checked === true).length;
                        setProductRow(productRow => productRow.filter(item => item.is_checked !== true) ) 
                        addProductRow(checkLenght)
                    }}
                    >ลบที่เลือก</button>
                    <button type='button' className='btn btn-st-x1 me-2' 
                    onClick={() => {
                        setProductRow(prev => prev.map((el) => {
                            return {
                                ...el, 
                                is_checked:false,
                            };
                        }));
                    }}
                    >ยกเลิก</button>
                </div>
            )
            : 
            customSort ? (
                <div className='mb-3 d-flex align-items-center mb-4'>
                    <div className='alert-w'>กรุณาเลือกที่แถวเพื่อจัดลำดับ</div>
                    <button
                        type='button'
                        className='btn btn-st-x1 me-2'
                        onClick={handleSaveSortOrder}
                        disabled={isSavingSort}
                    >
                        {isSavingSort ? 'กำลังบันทึก...' : 'บันทึกการจัดเรียง'}
                    </button>
                    <button
                        type='button'
                        className='btn btn-st-x1 me-2'
                        onClick={() => setCustomSort(false)}
                    >
                        ยกเลิกการจัดเรียง
                    </button>
                </div>
            ) :
            (
                <div className='flex gap-2 mb-4'>
                    <Button  variant="outlined" color='primary' size='small'  className='!bg-white !px-2 !border-[#D8D8DD]' 
                    onClick={(e) => {setModalLoadDocument( (prev) => ({...prev,open:true}) )}}
                    >เพิ่มเอกสาร </Button>
                    <Button  variant="outlined" color='primary' size='small'  className='!bg-white !px-2 !border-[#D8D8DD]' 
                    onClick={(e) => {setModalSort( (prev) => ({...prev,open:true}) )}}
                    >จัดเรียง </Button>

                    <Button  variant="outlined" color='primary' size='small'  className='!bg-white !px-2 !border-[#D8D8DD]' 
                    onClick={(e) => {
                        setModalDisplayColumn( (prev) => ({...prev,open:true}) )
                    }}
                    >ตัวเลือกแสดงผล </Button>
                </div>
            )
            }
            
            <div 
                className='pagezoom'
                style={{overflowX: 'auto',maxWidth: '100%',overflowY:'hidden',paddingBottom:'20px'}}
            >
            <DndContext 
                sensors={sensors}
                collisionDetection={closestCenter}
                onDragEnd={handleDragEnd}
                onDragCancel={handleDragCancel}
                onDragStart={handleDragStart}
                modifiers={[restrictToVerticalAxis]}
            >
                <SortableContext 
                    items={productRow}
                    strategy={verticalListSortingStrategy}
                >
                    <table className="column_resize_table table1 table-striped "  
                        style={{
                            width:'auto'
                        }}
                    >
                        <thead>
                            <tr>
                                <th>
                                    <div className="form-check form-check-st-t1">
                                        {
                                        customSort ? '' : (
                                        <input 
                                        className="form-check-input" 
                                            type="checkbox" 
                                            name=""   
                                            onChange={(e)=>{
                                                if(e.target.checked === true){
                                                    setProductRow(prev => prev.map((el) => {      
                                                        return {
                                                            ...el, 
                                                            is_checked:true,
                                                        };
                                                    }));
                                                }else{
                                                    setProductRow(prev => prev.map((el) => {
                                                        return {
                                                            ...el, 
                                                            is_checked:false,
                                                        };
                                                    }));
                                                } 
                                            }}
                                        />
                                        )}
                                    </div>
                                </th>
                                <ColumnResizer className="columnResizer" minWidth={35} />
                                {tableColumns.map((col) => (
                                    <React.Fragment key={col.key}>
                                        <th>{col.label}</th>
                                        <ColumnResizer className="columnResizer" minWidth={col.minWidth} />
                                    </React.Fragment>
                                ))}

    
                            </tr>
                        </thead>
                        <tbody>
                        
                        
                            {productRow.map((item, index) => (
                               
                                <ProductRow 
                                    item={item} 
                                    index={index} 
                                    setProductRow={setProductRow} 

                                    columdisplay={columdisplay}

                                    customSort={customSort}
                                    rowCount={rowCount}
                                    addProductRow={addProductRow}
                                    key={index}
                                    values={values}
                                    setFieldValue={setFieldValue}
                                    formdisabled={formdisabled}
                                />

                            ))}
                            
                        
                        
                        </tbody>
                        <tfoot>
                            <tr>
                                <td></td>
                                <td className="column_resizer_body" />
                                {tableColumns.map((col) => (
                                    <React.Fragment key={col.key}>
                                        <td></td>
                                        <td className="column_resizer_body" />
                                    </React.Fragment>
                                ))}
                            </tr>
                        </tfoot>
                    </table>
                </SortableContext>
                <DragOverlay >
                <table className="column_resize_table table1 table-striped  table-thead-0"  
                    style={{
                        width:'100%'
                    }}
                >
                    <thead>
                        <tr style={{height:0}}>
                            <th>
                            </th>
                            <ColumnResizer className="columnResizer" minWidth={35} />
                            <th></th>
                            <ColumnResizer className="columnResizer" minWidth={200} />
                            <th></th>
                            <ColumnResizer className="columnResizer" minWidth={200} />
                            {
                                columdisplay.barcode ? ( 
                                    <>
                                    <th></th>
                                    <ColumnResizer className="columnResizer" minWidth={100} />
                                    </>
                                ) : ''
                            }
                            {
                                columdisplay.supplierCode ? ( 
                                    <>
                                    <th></th>
                                    <ColumnResizer className="columnResizer" minWidth={130} />
                                    </>
                                ) : ''
                            }
                            <th></th>
                            <ColumnResizer className="columnResizer" minWidth={100} />
                            <th></th>
                            <ColumnResizer className="columnResizer" minWidth={100} />
                            <th></th>
                            <ColumnResizer className="columnResizer" minWidth={100} />
                            {
                                columdisplay.productsOrdered ? ( 
                                    <>
                                    <th style={{backgroundColor:'#FF731D',color:'#FFF'}}></th>
                                    <ColumnResizer className="columnResizer bg-FF731D" minWidth={100} />
                                    </>
                                ) : ''
                            }
                            {
                                columdisplay.ums ? ( 
                                    <>
                                    <th style={{backgroundColor:'#3FA5FF',color:'#FFF'}}></th>
                                    <ColumnResizer className="columnResizer bg-3FA5FF"bg-FF731D minWidth={100} />
                                    </>
                                ) : ''
                            }
                            {
                                columdisplay.productsStock ? ( 
                                    <>
                                    <th style={{backgroundColor:'#666CFF',color:'#FFF'}}></th>
                                    <ColumnResizer className="columnResizer bg-666CFF "  minWidth={100} />
                                    </>
                                ) : ''
                            }
                            <th></th>
                            <ColumnResizer className="columnResizer" minWidth={110} />
                            <th></th>
                            <ColumnResizer className="columnResizer" minWidth={140} />
                            <th></th>
                            <ColumnResizer className="columnResizer" minWidth={120} />
                            <th></th>
                            <ColumnResizer className="columnResizer" minWidth={80} />
                            <th></th>
                            <ColumnResizer className="columnResizer" minWidth={100} />
                            {
                                columdisplay.vat ? ( 
                                    <>
                                    <th></th>
                                    <ColumnResizer className="columnResizer" minWidth={120} />
                                    </>
                                ) : ''
                            }
                            {
                                columdisplay.valueIncludingTax ? ( 
                                    <>
                                    <th></th>
                                    <ColumnResizer className="columnResizer" minWidth={100} />
                                    </>
                                ) : ''
                            }
                            <th></th>
                            <ColumnResizer className="columnResizer" minWidth={100} />
                        </tr>
                    </thead>
                    <tbody>
                        <ProductRow 
                            item={selectedRow ? selectedRow[0] : ''} 
                            index={0} 
                            setProductRow={setProductRow} 
                            columdisplay={columdisplay}
                            customSort={customSort}
                            values={values}
                            formdisabled={formdisabled}
                        />
                    </tbody>
                </table>
                </DragOverlay>
            </DndContext>
            
            {
                !formdisabled && (
                    <Button variant="contained" color='primary' className='mx-3'
                    onClick={() => {
                        addProductRow(4)
                    }}
                    >+ เพิ่มเอกสาร</Button>
                )
            }
            
            </div>

            <ModalSelectMultipleProduct  
                modal={modal} 
                setModal={setModal}  
                productRow={productRow} 
                setProductRow={setProductRow} 
                addProductRow={addProductRow}
            />

            <ModalLoadDocument
                modal={modalLoadDocument}
                setModal={setModalLoadDocument}
                memberId={memberId}
                businessSlug={businessSlug}
                productRow={productRow}
                setProductRow={setProductRow}
                isTaxInvoice={values.is_tax_invoice}
            />
            <ModalSelectDocument 
                modal={modalSelectDocument} 
                setModal={setModalSelectDocument}
                documentName={documentName}
            />

            <ModalColumnDisplay 
                modal={modalDisplayColumn} 
                setModal={setModalDisplayColumn}
                column={columdisplay}
                setColumn={setColumDisplay}
            />


            <ModalProductHistory
                modal={modalProductHistory} 
                setModal={setModalProductHistory}
                productID={1}

            />

            <ModalSort
                modal={modalSort}
                setModal={setModalSort}
                onFormSubmit={(formdata) => {
                    sortProductRows(formdata);
                    setModalSort((prev) => ({ ...prev, open: false }));
                }}
                setCustomSort={setCustomSort}
            />


            

            

        </>
    )
}